module.exports = __webpack_public_path__ + "img/out_in_warehouse.15289282.png";